<!--
 * @Author: wsx
 * @Date: 2022-01-05 18:45:47
 * @LastEditTime: 2022-01-12 18:03:34
 * @LastEditors: your name
 * @Description:穿梭框应用
-->
<template>
  <el-card class="regionDetial" :body-style="treeCard">
    <el-input
      v-model="filterText"
      placeholder="请输入关键词"
      class="input-with-select"
    >
      <template #prefix>
        <i class="iconfont icon-31sousuo"></i>
      </template>
    </el-input>
    <div class="tree-box">
      <el-tree
        ref="treeRef"
        :data="dataSource"
        node-key="id"
        highlight-current
        :props="{ label: 'name' }"
        show-checkbox
        :expand-on-click-node="true"
        :filter-node-method="filterNode"
        @check-change="handleCheckChange"
        @current-change="currentChange"
      ></el-tree>
    </div>
  </el-card>
  <div class="form-button">
    <el-button type="primary" @click="submit">确认</el-button>
    <el-button @click="cancel">返回</el-button>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watch,
  watchEffect,
  ref,
  nextTick,
} from "vue";
import { getMenutree } from "@/api/system/region.js";

export default defineComponent({
  emits: ["cancel", "submit"],
  name: "regionDetial",
  components: {},
  props: {},
  setup(props, context) {
    const state = reactive({
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      dataSource: null,
      currentNode: {},
      selectedList: [],
      checkList: [],
      filterText: "",
    });
    const refData = toRefs(state);
    const treeRef = ref(null);
    // 组织树的筛选
    watch(
      () => state.filterText,
      (v) => {
        treeRef.value && treeRef.value.filter(v);
      }
    );

    // 当前选中节点变化时触发的事件
    const currentChange = (item, nodes) => {
      state.currentNode = item;
    };
    // 选中框点击
    const handleCheckChange = (value) => {
      if (treeRef.value) {
        let currentNode = treeRef.value.getCheckedNodes().length;
        if (currentNode >= 1) {
          treeRef.value.setCheckedNodes([]);
          treeRef.value.setChecked(value, true);
          state.selectedList = treeRef.value.getCheckedNodes();
          state.checkList = [treeRef.value.getCheckedNodes()[0].id];
        } else {
          state.selectedList = [];
          state.checkList = [];
        }
      }
    };
    // 对组织树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };
    // 获取结构树
    const queryOrganTreAsync = async () => {
      const result = await getMenutree();
      state.dataSource = [result.data];
      if (result.data) {
        currentChange(result.data);
        // nextTick(() => {
        //   state.rootNodeKey = state.currentNode.deptId;
        //   treeRef.value.setCurrentKey(state.currentNode.deptId);
        // });
      }
    };
    queryOrganTreAsync();
    const cancel = () => {
      context.emit("cancel");
    };
    const submit = () => {
      context.emit("submit", treeRef.value.getCheckedNodes());
      cancel();
    };
    return {
      ...refData,
      treeRef,
      filterNode,
      currentChange,
      handleCheckChange,
      submit,
      cancel,
    };
  },
});
</script>
<style lang="scss" scoped>
.regionDetial {
  height: 40vh;
  .tree-box {
    overflow: auto;
    margin-top: 16px;
  }
}
.form-button {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>
